// extracted by mini-css-extract-plugin
export default {"dropdown_element_container":"DropDown_dropdown_element_container__NrG9p"};